
(function() {
  var result = { translations: { "fr": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Actions" }, "tag": { "remove": "Supprimer le libell\xE9" }, "Select": { "noResults": "Aucun r\xE9sultat trouv\xE9", "searchPlaceholder": "Recherche...", "clearSelections": "Effacer les s\xE9lections" }, "ErrorMessage": { "error": { "title": "Tout n'est pas perdu." }, "notFound": { "title": "Ceux qui errent ne sont pas tous perdus." }, "badRequest": { "title": "Un probl\xE8me est survenu lors du chargement de cette page." }, "expired": { "title": "Nous sommes d\xE9sol\xE9s." }, "sessionId": { "prefix": "ID de session\xA0:" } }, "ProgressSteps": { "completedStep": "\xC9tape termin\xE9e", "incompleteStep": "\xC9tape incompl\xE8te" }, "Paginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "Vous \xEAtes actuellement sur", "description": "Page " }, "firstPage": { "label": "Premier", "description": "Premi\xE8re page" }, "previousPage": { "label": "Pr\xE9c\xE9dent", "description": "Page pr\xE9c\xE9dente" }, "nextPage": { "label": "Suivant", "description": "Page suivante" }, "lastPage": { "label": "Dernier", "description": "Derni\xE8re page" } }, "Datagrid": { "noData": { "Title": "Aucune donn\xE9e n'est disponible", "Description": "Il n'y a aucune donn\xE9e disponible \xE0 afficher." }, "noResults": { "Title": "Aucun r\xE9sultat trouv\xE9", "Description": "Essayez d'ajuster votre recherche et vos filtres pour trouver ce que vous cherchez.", "ClearActionLabel": "Effacez les recherches et les filtres" }, "toolbar": { "selectedRows": { "one": "{{count}}\xA0ligne s\xE9lectionn\xE9e", "other": "{{count}}\xA0lignes s\xE9lectionn\xE9es", "clearSelection": "Effacer la s\xE9lection", "selectAll": "S\xE9lectionner l'ensemble des {{totalRows}}\xA0lignes" }, "search": { "placeholder": "Rechercher", "label": "Rechercher", "clearSearch": "Effacer la recherche" } }, "pagination": { "visibleRows": "{{visibleRows}} sur {{totalRows}}\xA0r\xE9sultats", "itemsPerPage": "Articles par page", "countPerPage": { "one": "{{count}} par page", "other": "{{count}} par page", "many": "{{count}} par page" } }, "SkeletonGrid": { "loading": "Chargement en cours" }, "DataGridColumnManagementPanel": { "description": "Choisissez les propri\xE9t\xE9s \xE0 afficher sous forme de colonnes. Ensuite, d\xE9placez les propri\xE9t\xE9s vers le haut ou vers le bas, ou faites un glisser-d\xE9poser, pour modifier l'ordre dans lequel elles seront affich\xE9es.", "removeAllColumns": "Supprimer toutes les colonnes", "update": "Mise \xE0 jour", "cancel": "Annuler", "edit": "Modifier les colonnes" } } }, "ui": { "UIAbstractPageSection": { "page": "Section de la page" }, "UICarousel": { "current": "Afficher l'\xE9l\xE9ment {{currentStepDisplayNumber}}\xA0sur\xA0{{totalSteps}}", "prev": "Pr\xE9c\xE9dent", "next": "Suivant", "tip": "Utilisez les touches de fl\xE8ches pour voir d'autres \xE9l\xE9ments" }, "UIColorSwatch": { "label": "S\xE9lecteur de couleurs {{value}}", "noColorLabel": "S\xE9lecteur de couleur, aucune couleur s\xE9lectionn\xE9e." }, "UIButtonCollapser": { "dropdownLabel": "Actions" }, "UIErrorMessage": { "error": { "title": "Tout n'est pas perdu." }, "notFound": { "title": "Ceux qui errent ne sont pas tous perdus." }, "badRequest": { "title": "Un probl\xE8me est survenu lors du chargement de cette page." }, "expired": { "title": "Nous sommes d\xE9sol\xE9s." } }, "UIPanelNavigator": { "backButton": "Revenir \xE0 l'\xE9cran pr\xE9c\xE9dent" }, "UILoadingSpinner": { "busyText": "Chargement en cours", "completedText": "Charg\xE9" }, "UISideNav": { "navigationLandmark": "Secondaire" }, "UISortTH": { "ascendingSort": "Tri ascendant. Appuyez pour trier par ordre d\xE9croissant.", "descendingSort": "Tri descendant. Appuyez pour trier par ordre croissant.", "pressToSort": "Appuyez pour trier." }, "autosizedTextInput": { "charactersRemaining": "{{value}}\xA0caract\xE8res restants" }, "time": { "today": "Aujourd'hui \xE0 {{time}}", "yesterday": "Hier \xE0 {{time}}", "datetime": "{{date}} \xE0 {{time}}" }, "progress": { "percentComplete": "{{percent}} effectu\xE9" }, "datePicker": { "dateSelected": "{{date}} est s\xE9lectionn\xE9.", "noDateSelected": "Aucune date s\xE9lectionn\xE9e.", "dateBelowMin": "Vous devez choisir une date plus r\xE9cente", "dateAboveMax": "Vous devez choisir une date plus ancienne", "invalidDate": "Date non valide", "today": "Aujourd'hui", "clear": "Effacer", "placeholder": { "month": "MM", "day": "JJ", "year": "AAAA" }, "nextMonth": "Le mois prochain", "prevMonth": "Le mois pr\xE9c\xE9dent" }, "dateRange": { "startDate": "Date de d\xE9but", "endDate": "Date de fin", "endDateBeforeStartDate": "La date de fin doit \xEAtre post\xE9rieure \xE0 la date de d\xE9but.", "startDateAfterEndDate": "La date de d\xE9but doit \xEAtre ant\xE9rieure \xE0 la date de fin.", "to": "\xE0" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "...et {{count}} de plus.", "loadMore": "Voir plus" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Ajouter" }, "UIAvatarHoverlay": { "text": "Modifier la photo" }, "UIChangeArrow": { "decrease": "Diminution de", "increase": "Augmentation de" }, "UICopyInput": { "label": "Copier", "title": "Copier dans le presse-papiers", "tooltipCopied": "Copi\xE9" }, "UIConfirm": { "defaultConfirm": "Oui", "defaultReject": "Non" }, "UICloseButton": { "label": "Fermer" }, "UIDateRangePicker": { "rangeType": { "ALL": "Depuis le d\xE9but", "THIS_DAY": "Aujourd'hui", "LAST_DAY": "Hier", "THIS_WEEK": "Cette semaine", "LAST_WEEK": "La semaine derni\xE8re", "THIS_MONTH": "Ce mois-ci", "LAST_MONTH": "Le mois dernier", "LAST_THIRTY_DAYS": "Ces 30\xA0derniers jours", "LAST_THREE_MONTHS": "3\xA0derniers mois", "THIS_QUARTER": "Ce trimestre", "LAST_QUARTER": "Dernier trimestre", "THIS_YEAR": "Cette ann\xE9e", "LAST_YEAR": "L'ann\xE9e derni\xE8re", "CUSTOM": "P\xE9riode personnalis\xE9e" } }, "UIDropdownSelect": { "placeholder": "Aucune valeur s\xE9lectionn\xE9e" }, "UIEditableControls": { "cancel": "Annuler", "save": "Enregistrer" }, "UIExpandableText": { "collapseButtonText": "Afficher moins", "expandButtonText": "Afficher plus" }, "UIFileInput": { "defaultChangeLabel": "Modifier un fichier", "defaultSelectLabel": "S\xE9lectionner un fichier" }, "UIIconRating": { "ariaValueText": "{{value}} sur {{maxValue}}" }, "UILink": { "externalTitle": "Le lien s'ouvre dans un nouvel onglet" }, "UILoading": { "title": "Chargement en cours..." }, "UILockBadge": { "title": "Cette fonctionnalit\xE9 est verrouill\xE9e" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "Vous \xEAtes actuellement sur", "description": "Page " }, "firstPage": { "label": "Premier", "description": "Premi\xE8re page" }, "previousPage": { "label": "Pr\xE9c\xE9dent", "description": "Page pr\xE9c\xE9dente" }, "nextPage": { "label": "Suivant", "description": "Page suivante" }, "lastPage": { "label": "Dernier", "description": "Derni\xE8re page" } }, "UIPreviousButton": { "label": "Pr\xE9c\xE9dent" }, "UINextButton": { "label": "Suivant" }, "UINumberRating": { "lowRangeLabel": "Pas du tout d'accord", "highRangeLabel": "Tout \xE0 fait d'accord" }, "UISearchableSelectInput": { "placeholder": "Rechercher" }, "UISearchInput": { "placeholder": "Rechercher", "minimumSearchMessage": { "one": "Saisissez 1\xA0caract\xE8re en plus", "other": "Saisissez {{count}}\xA0caract\xE8res en plus", "many": "Saisissez {{count}}\xA0de caract\xE8res en plus" }, "clearButton": "Supprimer l'entr\xE9e" }, "UISelect": { "allOptionsSelected": "Toutes les options sont s\xE9lectionn\xE9es", "createOption": "Cr\xE9er l'option \xAB\xA0{{label}}\xA0\xBB", "plusMore": "+ {{count}} de plus", "andMore": "...et {{count}} de plus.", "loadMore": "Voir plus", "noResults": "Aucun r\xE9sultat trouv\xE9", "placeholder": "Rechercher", "typeToSearch": "Saisissez du texte pour faire une recherche" }, "UITable": { "selectableTableRow": { "toggleSelection": "Afficher/masquer la s\xE9lection de la ligne" } }, "UITabs": { "moreDropdownLabel": "Plus" }, "UITeaseNotification": { "optionsButtonTooltipText": "Afficher les options" }, "UITimePicker": { "placeholder": "S\xE9lectionner une heure" }, "UIToggle": { "checkedLabel": "ACTIV\xC9", "uncheckedLabel": "D\xC9SACTIV\xC9" }, "UITypeahead": { "noMatchesFound": "Aucune correspondance n'a \xE9t\xE9 trouv\xE9e", "noOptions": "Aucun" }, "UIWizard": { "back": "Retour", "cancel": "Annuler", "done": "Termin\xE9", "next": "Suivant", "stepCount": "\xC9tape {{stepNumber}} sur {{stepCount}}" }, "XSSTooltip": { "explanation": "Ce lien a \xE9t\xE9 d\xE9sactiv\xE9 pour votre s\xE9curit\xE9." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "fr": "static-1.5419"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.5419",
    "ar-eg": "static-1.5419",
    "bg": "static-1.5419",
    "bn": "static-1.5419",
    "ca-es": "static-1.5419",
    "cs": "static-1.5419",
    "da": "static-1.5419",
    "de": "static-1.5419",
    "el": "static-1.5419",
    "en-gb": "static-1.5419",
    "en": "static-1.5419",
    "es-mx": "static-1.5419",
    "es": "static-1.5419",
    "et": "static-1.5419",
    "fi": "static-1.5419",
    "fr-ca": "static-1.5419",
    "fr": "static-1.5419",
    "he-il": "static-1.5419",
    "hi": "static-1.5419",
    "hr": "static-1.5419",
    "hu": "static-1.5419",
    "id": "static-1.5419",
    "it": "static-1.5419",
    "ja": "static-1.5419",
    "ko": "static-1.5419",
    "lt": "static-1.5419",
    "ms": "static-1.5419",
    "nl": "static-1.5419",
    "no": "static-1.5419",
    "pl": "static-1.5419",
    "pt-br": "static-1.5419",
    "pt-pt": "static-1.5419",
    "ro": "static-1.5419",
    "ru": "static-1.5419",
    "sk": "static-1.5419",
    "sl": "static-1.5419",
    "sv": "static-1.5419",
    "th": "static-1.5419",
    "tl": "static-1.5419",
    "tr": "static-1.5419",
    "uk": "static-1.5419",
    "vi": "static-1.5419",
    "zh-cn": "static-1.5419",
    "zh-hk": "static-1.5419",
    "zh-tw": "static-1.5419"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:fr', {version: 'static-1.5419'}); }
})();



(function() {
  var result = { translations: { "fr": { "placeholder": "variable" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "fr": "static-3.6763"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6763",
    "ar-eg": "static-3.6763",
    "bg": "static-3.6763",
    "bn": "static-3.6763",
    "ca-es": "static-3.6763",
    "cs": "static-3.6763",
    "da": "static-3.6763",
    "de": "static-3.6763",
    "el": "static-3.6763",
    "en-gb": "static-3.6763",
    "en": "static-3.6763",
    "es-mx": "static-3.6763",
    "es": "static-3.6763",
    "et": "static-3.6763",
    "fi": "static-3.6763",
    "fr-ca": "static-3.6763",
    "fr": "static-3.6763",
    "he-il": "static-3.6763",
    "hi": "static-3.6763",
    "hr": "static-3.6763",
    "hu": "static-3.6763",
    "id": "static-3.6763",
    "it": "static-3.6763",
    "ja": "static-3.6763",
    "ko": "static-3.6763",
    "lt": "static-3.6763",
    "ms": "static-3.6763",
    "nl": "static-3.6763",
    "no": "static-3.6763",
    "pl": "static-3.6763",
    "pt-br": "static-3.6763",
    "pt-pt": "static-3.6763",
    "ro": "static-3.6763",
    "ru": "static-3.6763",
    "sk": "static-3.6763",
    "sl": "static-3.6763",
    "sv": "static-3.6763",
    "th": "static-3.6763",
    "tl": "static-3.6763",
    "tr": "static-3.6763",
    "uk": "static-3.6763",
    "vi": "static-3.6763",
    "zh-cn": "static-3.6763",
    "zh-hk": "static-3.6763",
    "zh-tw": "static-3.6763"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:fr', {version: 'static-3.6763'}); }
})();



(function() {
  var result = { translations: { "fr": { "app": { "htmlTitle": "IU de liens viraux", "welcomeHome": "Bienvenue chez vous {{ firstName }}", "yourAppIsReady": "Votre application est pr\xEAte", "aSecondPage": "Une deuxi\xE8me page qui contiendra plus de contenu", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "Remplissez cette page vide avec des ", createElement( options, "Link", props.linkProps, "composants" ), " \xE0 ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Cr\xE9ez vos propres formulaires gratuits</strong> pour g\xE9n\xE9rer des leads depuis votre site Internet." }, "liveChat": { "linkCta": "<strong>Ajoutez le chat en direct.</strong> Interagissez avec les visiteurs.", "ariaLabel": "Ajoutez le chat en direct. Interagissez avec les visiteurs gratuitement." }, "liveChatIntermediate": { "linkCta": "<strong>[Int] Ajoutez le chat en direct.</strong> Interagissez avec les visiteurs gratuitement.", "ariaLabel": "[Int] Ajoutez le chat en direct. Interagissez avec les visiteurs gratuitement." }, "meetings": { "linkCta": "<strong>Cr\xE9ez gratuitement votre page de r\xE9servation de r\xE9unions</strong> pour planifier des r\xE9unions plus rapidement." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "fr": "static-1.4475"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.4475",
    "ar-eg": "static-1.4475",
    "bg": "static-1.4475",
    "bn": "static-1.4475",
    "ca-es": "static-1.4475",
    "cs": "static-1.4475",
    "da": "static-1.4475",
    "de": "static-1.4475",
    "el": "static-1.4475",
    "en-gb": "static-1.4475",
    "en": "static-1.4475",
    "es-mx": "static-1.4475",
    "es": "static-1.4475",
    "et": "static-1.4475",
    "fi": "static-1.4475",
    "fr-ca": "static-1.4475",
    "fr": "static-1.4475",
    "he-il": "static-1.4475",
    "hi": "static-1.4475",
    "hr": "static-1.4475",
    "hu": "static-1.4475",
    "id": "static-1.4475",
    "it": "static-1.4475",
    "ja": "static-1.4475",
    "ko": "static-1.4475",
    "lt": "static-1.4475",
    "ms": "static-1.4475",
    "nl": "static-1.4475",
    "no": "static-1.4475",
    "pl": "static-1.4475",
    "pt-br": "static-1.4475",
    "pt-pt": "static-1.4475",
    "ro": "static-1.4475",
    "ru": "static-1.4475",
    "sk": "static-1.4475",
    "sl": "static-1.4475",
    "sv": "static-1.4475",
    "th": "static-1.4475",
    "tl": "static-1.4475",
    "tr": "static-1.4475",
    "uk": "static-1.4475",
    "vi": "static-1.4475",
    "zh-cn": "static-1.4475",
    "zh-hk": "static-1.4475",
    "zh-tw": "static-1.4475"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:fr', {version: 'static-1.4475'}); }
})();


